const EVENTS_LOADING = "EVENTS_LOADING";
const EVENTS_SUCCESS = "EVENTS_SUCCESS";
const EVENTS_ERROR = "EVENTS_ERROR";

export {
    EVENTS_LOADING,
    EVENTS_ERROR,
    EVENTS_SUCCESS,
};